var map = {
	"./address.svg": "0e25",
	"./agency.svg": "e45b",
	"./app.svg": "43bc",
	"./banner.svg": "5544",
	"./bottom.svg": "9a94",
	"./box.svg": "acdb",
	"./branch.svg": "58a7",
	"./brand-positioning.svg": "1424",
	"./comment.svg": "03ee",
	"./credit-card.svg": "80ca",
	"./dashboard.svg": "f782",
	"./email-otp-solid.svg": "b362",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./gift.svg": "3d7b",
	"./handshake.svg": "88d5",
	"./link.svg": "18f0",
	"./modules.svg": "abe3",
	"./nested.svg": "dcf8",
	"./note.svg": "8798",
	"./order.svg": "11ff",
	"./password.svg": "2a3d",
	"./processor.svg": "2fbc",
	"./products.svg": "0e1b",
	"./reports.svg": "8d5f",
	"./settings.svg": "3fc8",
	"./system.svg": "30a9",
	"./table.svg": "47f1",
	"./text.svg": "c5f6",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./view-news.svg": "77cd",
	"./view-product.svg": "cc42",
	"./web.svg": "d02d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";